<template>
	<div class="modal-container" :class="{'no-footer': !footer}">

		<transition name="fade" appear>
			<div class="modal-mask" ref="modalMask" @click="handleMaskClick"></div>
		</transition>

		<transition name="slide-fade" appear>
			<div
				class="modal-wrapper"
				@click.self="handleWrapperClick"
				:class="{ droppable: dropzone }"
				@drop.prevent="handleDrop"
				@dragover.prevent="droppable = true"
				@dragleave.prevent="droppable = false"
			>
				<div
					class="basic-modal"
                    :style="{width: wWidth + 'px', height: wHeight ? wHeight : 'auto'}"
				>
					<div class="modal" :style="{ width: '100%', height: 'auto', display: 'block' }" ref="modal">
						<div class="progress-line" v-if="loading"></div>
						<div class="modal-heading">
							<div class="modal-title" v-if="$slots.title">
								<slot name="title"></slot>
							</div>
							<div class="modal-close" v-if="!hideClose" @click="handleClose">
								<span class="icon icon-close"></span>
							</div>
						</div>
						<div class="modal-body">
                            <!-- <vue-scroll> -->
							<slot></slot>
                            <!-- </vue-scroll> -->
						</div>
						<div v-if="footer" :class="['modal-footer', alt ? 'modal-alt' : '']">
							<template v-if="$slots.footer">
								<slot name="footer"></slot>
							</template>
							<div class="modal-actions" v-else>
								<div>
									<el-button :size="buttonSize" @click="cancel" v-if="!hideCancel">{{ cancelText }}</el-button>
									<el-button :size="buttonSize" @click="okSecondary" v-if="!hideOkSecondary" :disabled="okSecondaryDisabled" :type="okSecondaryType">
										{{ okSecondaryText }}
									</el-button>
									<el-button :size="buttonSize" @click="ok" v-if="!hideOk" :disabled="okDisabled" :type="okType">{{ okText }}</el-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: "XModalBasic",
		props: {
			alt: {
				type: [Boolean, String],
				default: false,
			},
			parent: {
				type: Boolean,
				required: false,
				default: false,
			},
			okText: {
				default: "Ok",
			},
			okSecondaryText: {
				default: "Ok",
			},
			okDisabled: {
				type: Boolean,
				default: false,
			},
			okSecondaryDisabled: {
				type: Boolean,
				default: false,
			},
            okType: {
                type: String,
                required: false,
                default: 'success'
            },
            okSecondaryType: {
                type: String,
                required: false,
                default: 'success'
            },
			hideOk: {
				type: Boolean,
				default: false,
			},
			hideOkSecondary: {
				type: Boolean,
				default: true,
			},
			hideCancel: {
				type: Boolean,
				default: false,
			},
			cancelText: {
				default: "Cancel",
			},
			wWidth: {
				default: 650,
			},
            wHeight: {
				default: "auto",
			},
			minWidth: {
				type: Number,
				default: 500,
			},
			minHeight: {
				type: Number,
				default: 300,
			},
			loading: {
				type: Boolean,
				default: false,
			},
			hideClose: {
				type: Boolean,
				default: false,
			},
			footer: {
				type: Boolean,
				default: true,
			},
			dropzone: {
				type: Boolean,
				default: false,
			},
			draggable: {
				type: Boolean,
				default: false,
			},
			resizable: {
				type: Boolean,
				default: false,
			},
            buttonSize: {
                type: String,
                default: ''
            }
		},
		data() {
			return {
				droppable: false,
				positionX: 0,
				positionY: 0,
			}
		},
		methods: {
			handleClose(e) {
				this.$emit("close")
				this.close()
			},
			handleMaskClick(e) {
				// this.close()
			},
			cancel() {
				this.$emit("cancel")
			},
			ok() {
				this.$emit("ok")
			},
			okSecondary() {
				this.$emit("okSecondary")
			},
			close() {
				this.cancel()
			},
			handleWrapperClick() {
				// this.close()
			},
			handleKeyCode(evt) {
				if (evt.keyCode === 27) {
					// esc
					this.close()
				}
			},
			handleDrop(payload) {
				if (this.dropzone) {
					this.$bus.$emit("modal::file::dropped", payload)
				}
			},
			getPositionX: function () {
				const wWidth = $(window).outerWidth()
				const elWidth = 650 //$(this.$refs.modal).outerWidth();
				return wWidth / 2 - elWidth / 2
			},
			getPositionY: function () {
				const wHeight = $(window).outerHeight()
				const elHeight = 600 //$(this.$refs.modal).outerHeight();
				return wHeight / 2 - elHeight / 2
			},
			onDrag: function (x, y) {
				const modalMask = $(this.$refs.modalMask)
				modalMask.addClass("mask-dragged")

				const modalLoaded = $(this.$refs.modal)
				modalLoaded.addClass("mask-dragged")
			},
			onDragStop: function (x, y) {},
		},
		mounted() {
			document.addEventListener("keydown", this.handleKeyCode)
			this.positionX = this.getPositionX()
			this.positionY = this.getPositionY()
		},
		beforeDestroy() {
			document.removeEventListener("keydown", this.handleKeyCode)
		},
        computed: {
            maxWidth() {
                return window.innerWidth - 20
            },
            maxHeight() {
                return window.innerHeight - 20
            },
        }
	}
</script>

<style lang="scss">
	.basic-modal {
        max-width: 95% !important;
		&.vdr {
			border: none !important;
		}
	}

	.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__segment-percentages {
		z-index: 1 !important;
	}

	.btn-success.disabled,
	.btn-success:disabled {
		background-color: #a7aba8 !important;
		border-color: #a7aba8 !important;
	}

	.modal-container {
		.modal-wrapper {
			.modal-body {
				> .container {
					max-height: 100%;
				}
			}
		}

        &.no-footer {
            .modal-wrapper {
                .modal-body {
                    height: 100% !important;
                }
            }
        }
	}
</style>
